module.exports = __webpack_public_path__ + "static/media/ProcessFlowChart.a19a0121.png";